import React from 'react'

import EnvConstants from 'app/services/core/config.service'
import AuthApi from 'app/services/core/login.service'

import { Block, Text, List } from 'app/components/common'
import LearnMoreModalButton from 'app/components/buttons/error-learn-more/error-learn-more.component'
import ErrorComponent from 'app/components/errors/error.component'
import robotImage from 'app/components/errors/assets/robot-happy.svg'

import 'app/pages/errors/error-page.scss'

const NoLicensePage = () => (
  <Block type="main" className="error-page">
    <ErrorComponent
      button
      topGoBack
      onGoBack={() => AuthApi.logoutTo(EnvConstants.CKLA_LANDING_URL)}
      title="Coming Soon!"
      CustomButton={LearnMoreModalButton}
      robotImage={robotImage}
    >
      <>
        <Text className="h-mt-10">
          Currently you don’t have access to the Hub.
        </Text>
        <List
          markerStyle="bullet"
          text="*-- If you are a new customer, you will be up and running once your school district completes enrollment.
         *-- If you are a returning customer, you are still able to log in to the Resource Site with your mCLASS credentials and will have access to the Hub once your school district completes enrollment for this school year."
        />
        <Text className="h-mt-10">
          Please check back soon. We are excited to welcome you to the Hub!
        </Text>
      </>
    </ErrorComponent>
  </Block>
)

export default NoLicensePage
